import React, { useCallback, useEffect, useRef, useState } from 'react'
import Table, { Column, TableHandle } from '../../../components/Table';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { Button } from '../../../components/Button';
import { FaEdit } from 'react-icons/fa';
import { LightColors } from '../../../utils/colors/colors';
import { useNavigate } from 'react-router-dom';
import FilterForm from './Components/FilterForm';
import { fetchPropertyForSale } from '../../../redux/slices/propertiesForSale/thunk';
import { Property, setFilterData } from '../../../redux/slices/propertiesForSale/slice';
import Checkbox from '../../../components/Checkbox';
import { formattedAmount } from '../../../helper/currencyFormatter';
import { formatIndianNumber } from '../../../helper/numberFormate';

const UserProperties = () => {
  const dispatch: any = useDispatch()
  const tableRef = useRef<TableHandle>(null);
  const navigate = useNavigate();
  const {
    propertySaleList,
    filterData
  } = useSelector((state: RootState) => state.propertiesForSale)


  const [refresh, setRefresh] = useState(false)
  const [showLoader, setShowLoader] = useState(false)

  // Table columns for User
  const columns: Column<Property | any>[] = [
    { key: "city", label: "City", sortable: true },
    {
      key: "area", label: "Area / Street",
      customCell: (row) => (
        <div className=''>
          {/* Fallback to .name just in case your backend uses name instead of area */}
          <div className=''> {`${row?.area?.area || ""} /` || "-"}</div>
          <div className=''> {row?.street?.street|| "-"}</div>
        </div>
      )
    },
    // 👈 Added Street Column
    // {
    //   key: "street", label: "Street",
    //   customCell: (row) => (
    //     <div className='flex'>
    //       {row?.street?.street|| "-"}
    //     </div>
    //   )
    // },
    {
      key: "propertyType", label: "Property Type",
      customCell: (row) => (
        <div className='flex'>
          {row?.propertyType?.propertyType || row?.propertyType?.name || "-"}
        </div>
      )
    },
    { key: "surveyNumber", label: "Survey Number" },
    {
      key: "areaSqFt", label: "Area (SqFt)",
      customCell: (row) => (
        <div className='flex'>
          {formatIndianNumber(row?.areaSqFt)}
        </div>
      )
    },
    // 👈 Added Building Specs Column
    {
      key: "buildingDetails", label: "Building Specs",
      customCell: (row) => (
        row?.hasBuilding ? (
          <div className='flex flex-col text-xs text-subTitleText'>
            <span><b className="text-headingText">BUA:</b> {formatIndianNumber(row?.bua)}</span>
            <span><b className="text-headingText">Floors:</b> {row?.floors}</span>
            <span><b className="text-headingText">Facing:</b> {row?.facing}</span>
          </div>
        ) : (
          <span className="text-gray-400 text-sm">N/A</span>
        )
      )
    },
    {
      key: "sellingPrice", label: "Market Rate",
      customCell: (row) => (
        <div className='flex'>
          {formattedAmount(row?.sellingPrice)}
        </div>
      )
    },
    {
      key: "userId", label: "Listed By", customCell: (row) => (
        <div className='text-sm'>
          <p className="font-medium text-headingText">
            {row?.userId?.name || "Unknown"}({row?.userId?.userType || "N/A"})
          </p>
          <p className="text-subTitleText">
            {row?.userId?.mobileNumber}
          </p>
        </div>
      )
    },
    {
      key: "isApproved", label: "Approved",
      customCell: (row) => (
        <div className='flex justify-center items-center'>
          <Checkbox
            checked={row.isApproved ? true : false}
            onCheckedChange={function (checked: boolean) {
              // TODO: Implement quick-approval API toggle here if needed
            }}
          />
        </div>)
    },
    {
      key: "action",
      label: "Actions",
      sortable: false,
      customCell: (row) => (
        <div className='flex justify-center items-center'>
          <a
            className="text-blue-600 cursor-pointer hover:opacity-80 transition-opacity"
            onClick={() => navigate(`/Properties-for-sale/edit/${row._id}`, { state: { row } })}
            role="button"
            tabIndex={0}
          >
            <FaEdit color={LightColors.accent} size={20} />
          </a>
        </div>
      ),
    },
  ];

  const onSortChanged = (sortBy: any, sortOrder: any) => {
    dispatch(setFilterData({
      ...filterData,
      sortBy: sortBy,
      sortOrder: sortOrder
    }))
  };

  const getData = async () => {
    setShowLoader(true)
    await dispatch(fetchPropertyForSale({
      ...filterData,
    }));
    setShowLoader(false)
  }

  useEffect(() => {
    getData()
  }, [
    filterData.page,
    filterData.limit,
    filterData.city,
    filterData.state,
    filterData.search,
    filterData.sortBy,
    filterData.sortOrder,
    refresh
  ]);

  return (
    <div>
      <Table
        ref={tableRef}
        columns={columns as any}
        data={propertySaleList}
        tableName="Properties For Sale"
        totalCount={filterData.totalCount}
        currentPage={filterData.page}
        pageSize={filterData.limit}
        filterContent={<FilterForm tableRef={tableRef} />}
        onSearchChange={(searchText) => {
          dispatch(setFilterData({ ...filterData, search: searchText, page: 1 }));
        }}
        onPageChange={(page) => {
          dispatch(setFilterData({
            ...filterData,
            page: page
          }))
        }}
        onPageSizeChange={(size: number) => {
          dispatch(setFilterData({
            ...filterData,
            limit: size,
            page: 1
          }))
        }}
        loading={showLoader}
        renderRightToolItems={
          <div className='flex gap-2'>
            <Button
              variant="primary"
              onClick={() => setRefresh(!refresh)}
            >
              Refresh
            </Button>

            <Button
              variant="primary"
              onClick={() => {
                navigate("/Properties-for-sale/add")
              }}
            >Add</Button>
          </div>
        }
        onSortChange={onSortChanged}
      />
    </div>
  )
}

export default UserProperties